import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login/Login';
import VendorLogin from './components/VendorLogin/VendorLogin';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import Dashboard from './components/Dashboard/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
//import './App.css';
import './assets/styles/theme.css';
import IdleLogout from './components/IdleLogout/IdleLogout';
import PublicRoute from './contexts/PublicRoute';
import { LOGIN_ROUTE, LEGACY_LOGIN_ROUTE, VENDOR_LOGIN_ROUTE, PRIVACY_POLICY_ROUTE } from './constants/routes';

/**
 * The login screen lives at "/", but other services and old bookmarks still
 * link to "/login". Alias it rather than leaving that path matching nothing.
 * The query string is carried over — the handoff depends on ?redirectUrl.
 */
const LegacyLoginRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: LOGIN_ROUTE, search }} replace />;
};

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#667eea',
          borderRadius: 8,
        },
      }}
    >
      <Router>
        <AuthProvider>
          <IdleLogout /> 
          <Routes>
            <Route path="/" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            <Route path={LEGACY_LOGIN_ROUTE} element={<LegacyLoginRedirect />} />
            {/* Vendors sign in with a mobile number + OTP — they hold no
                platform password, so the employee form has nothing to offer them. */}
            <Route path={VENDOR_LOGIN_ROUTE} element={
              <PublicRoute>
                <VendorLogin />
              </PublicRoute>
            } />
            <Route path="/forgot-password" element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            } />
            {/* Reached from the reset mail — intentionally outside PublicRoute so a
                signed-in user following the link still lands on the reset screen. */}
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Static page — outside PublicRoute so signed-in users can read it too. */}
            <Route path={PRIVACY_POLICY_ROUTE} element={<PrivacyPolicy />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} /> */}
          </Routes>
        </AuthProvider>
      </Router>
    </ConfigProvider>
  );
};

export default App;
